import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import MenuHeader from '../../components/Layout/MenuHeader';
import MenuFooter from '../../components/Layout/MenuFooter';
import Box from '@mui/material/Box';
import ListCard from '../../components/ListCard';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import './styles.scss';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OverlayLoader from '../../components/OverlayLoader';
import { showToast } from '../../utils/toast';

import HttpClient from '../../helpers/HttpClient'; 

const Home = () => {
  const [openLoader, setOpenLoader] = React.useState(true);
  const [courses, setCourses] = useState([]);
  const [percentage, setPercentage] = React.useState(0);
  const [legalPage, setLegalPage] = React.useState('<div></div>');
  const [website, setWebsite] = React.useState('');
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
  const userId = authState.user ? authState.user.email : "test"
  const getCourses = async() => {

    //llamado a api
    const request = await HttpClient().get(`/courses/home/${userId}`);
    console.log(request)
    if (request.error) {
      setOpenLoader(false);
      showToast("No se pudo cargar información de cursos. Refresca la página e intenta nuevamente.", "error");
      return;
    }

    const generalTem = request.data.general;

    if (generalTem){
      setLegalPage(generalTem.paginalegal)
      setWebsite(generalTem.sitioweb)
    }

    const result = request.data.courses;
    console.log(result)
    if (result) {
      if (result.length && result.length > 0) {
          setCourses(result);

        const sublessonsHistory = request.data.sublessonsHistory;
  
        if (sublessonsHistory && sublessonsHistory.length > 0){
          const views = sublessonsHistory.filter(ele => ele.viewed > 0).length;
          setPercentage(parseInt((views * 100) / sublessonsHistory.length))
        }
      }else{
        showToast("No se encontraron cursos disponibles");
      }
    }else{
      console.log(result)
      showToast("Ocurrió un error. Intenta nuevamente.", "error");
    }
    setOpenLoader(false);
  }

  useEffect(()=>{
    getCourses();
  }, []);

    return (
        <React.Fragment>
            <CssBaseline />
            <Container disableGutters className="f-container fixed-hf">
            <OverlayLoader open={openLoader} />
                <Box className="header">
                    <MenuHeader 
                      progress={percentage}
                    />
                </Box>
                
                <Box className="main">
                    <div className='courses-container'>
                        <div className='title'>
                        <Typography variant="h4" color="text.primary" gutterBottom>
                            Cursos
                        </Typography>
                        </div>
                        <div className='list-container'>
                            <Grid container columns={{ xs: 4, md: 12 }} spacing={2}>
                              {courses.map((card, index) => (
                                <Grid item xs={4} key={index}>
                                  <ListCard cardData={card} onCardClick={()=>{
                                    navigate("/course/" + card.cod_curso);
                                  }}/>
                                </Grid>
                              ))}
                            </Grid>
                        </div>
                    </div>
                </Box>
                <Box className="footer">
                    <MenuFooter 
                      legalPage={legalPage}
                      website={website}
                    />
                </Box>
                {/*<ToastContainer limit={3} autoClose={3000} />*/}
            </Container>
        </React.Fragment>
    )
}

export default React.memo(Home);